import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  UrlCreationOptions,
} from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private Obs: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject<
    Breadcrumb[]
  >([]);

  private breadcrumbs: Breadcrumb[] = [];

  public getbreadcrumbs(): BehaviorSubject<Breadcrumb[]> {
    return this.Obs;
  }

  /**
  /*.filter(event => event instanceof NavigationEnd)
 .distinctUntilChanged()
 .map(event =>  this.buildBreadCrumb(this.activatedRoute.root)); */

  constructor(private router: Router, private route: ActivatedRoute) {
    let breadcrumb: Breadcrumb;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        // ricerca diretta in home?
        if (router.url == '/directsearch') {
          this.Obs.next([
            {
              label: 'ricerca diretta',
              url: '',
            } as Breadcrumb,
          ]);
        } 
        else if(router.url == '/GuidedSearch' || router.url == '/GuidedSearchQuestionario') {
          this.Obs.next([
            {
              label: 'Ricerca guidata',
              url: '/GuidedSearch',
            } as Breadcrumb,
          ]);
        }
        else if(router.url.startsWith('/policy')) {
          this.Obs.next([
            {
              label: 'Ricerca',
              url: null,
            } as Breadcrumb,
            {
              label: 'Dettaglio',
              url: null,
            } as Breadcrumb,
          ]);
        }
        else {
          let root: ActivatedRoute = this.route.root;
          this.breadcrumbs = this.getBreadcrumbs(root);
          this.Obs?.next(this.breadcrumbs);
          this.breadcrumbs = [breadcrumb, ...this.breadcrumbs];
        }
      });
  }

  private getBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'title';
    //get the child routes
    let children: ActivatedRoute[] = route.children;
    //console.log(route);
    //console.log(route.children);

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET || child.snapshot.url.length == 0) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');

      //append route URL to URL
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: Breadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        url: url,
      };
      breadcrumbs.push(breadcrumb);

      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}

export interface Breadcrumb {
  label: string;
  url: string;
}
